export default __webpack_public_path__ + "static/graphics-51a2a3702127f124ff74126c092e4a95.png";